import React, { useState } from 'react'
import axios from 'axios'
import { useDispatch } from 'react-redux'
import Configuration from '../Configuration'
import { addProduct } from '../reducers/product-settings'

// Reuses WooCommerce core's own product-search AJAX endpoint (the same one
// WC's own admin screens use for e.g. up-sells/cross-sells pickers) instead
// of building a custom search endpoint.
const searchProducts = (term, callback) => {
  const config = Configuration.getInstance()
  const url = window.ajaxurl + '?action=woocommerce_json_search_products'
    + '&term=' + encodeURIComponent(term)
    + '&security=' + encodeURIComponent(config.search_products_nonce)
  axios.get(url).then(response => callback(response.data || {})).catch(err => {
    console.error('Dreamfox WDD: error searching products', err)
  })
}

const ProductPicker = () => {
  const dispatch = useDispatch()
  const [term, setTerm] = useState('')
  const [results, setResults] = useState({})
  const [searching, setSearching] = useState(false)

  const handleTermChange = (e) => {
    const value = e.target.value
    setTerm(value)
    if (value.length < 3) {
      setResults({})
      return
    }
    setSearching(true)
    searchProducts(value, (data) => {
      setSearching(false)
      setResults(data)
    })
  }

  const handlePick = (id, name) => {
    dispatch(addProduct({ id: parseInt(id, 10), name }))
    setTerm('')
    setResults({})
  }

  return (
    <div className="dreamfox-product-picker">
      <input
        type="text"
        className="dreamfox-product-picker__input"
        placeholder="Search for a product to add…"
        value={term}
        onChange={handleTermChange}
      />
      {searching && <div className="dreamfox-product-picker__status">Searching…</div>}
      {Object.keys(results).length > 0 &&
        <ul className="dreamfox-product-picker__results">
          {Object.entries(results).map(([id, name]) =>
            <li key={id} onClick={() => handlePick(id, name)}>{name}</li>
          )}
        </ul>
      }
    </div>
  )
}

export default ProductPicker
